import { request } from "./request";

/** 技师列表（分页 + 条件查询） */
export function listTechnicians(data = {}) {
  return request("/chair/listTechnicians", {
    method: "POST",
    body: {
      pageNum: Number(data.pageNum) || 1,
      pageSize: Number(data.pageSize) || 10,
      workerId: String(data.workerId ?? "").trim(),
      realName: String(data.realName ?? "").trim(),
      phone: String(data.phone ?? "").trim(),
    },
  });
}

export function listTechniciansSimple() {
  return request("/chair/listTechniciansSimple", {
    method: "GET",
  });
}

export function addTechnicianInfo(data) {
  return request("/chair/addTechnicianInfo", {
    method: "POST",
    body: {
      workerId: data.workerId,
      realName: data.realName,
      phone: data.phone,
      sex: Number(data.sex),
      region: data.region,
      sitePositioning: data.sitePositioning,
      projectIds: (data.projectIds || []).map((id) => String(id)),
      deviceIds: (data.deviceIds || []).map((id) => String(id)),
    },
  });
}

export function updateTechnicianInfo(data) {
  return request("/chair/updateTechnicianInfo", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      workerId: data.workerId,
      realName: data.realName,
      phone: data.phone,
      sex: Number(data.sex),
      region: data.region,
      sitePositioning: data.sitePositioning,
      projectIds: (data.projectIds || []).map((id) => String(id)),
      deviceIds: (data.deviceIds || []).map((id) => String(id)),
    },
  });
}

export function deleteTechnicianInfo(data) {
  return request("/chair/deleteTechnicianInfo", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
    },
  });
}


export function relateClinicCodes(data) {
  return request("/chair/relateClinicCodes", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      hospitalCode: String(data.hospitalCode ?? "").trim(),
    },
  });
}

export function deleteTechnicianClinicCode(data) {
  return request("/chair/deleteTechnicianClinicCode", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      hospitalCode: String(data.hospitalCode).trim(),
    },
  });
}
